export const staffImportTokens = {
    spacing: {
        pagePaddingX: 64,
        pagePaddingY: 32,
        sectionGap: 16,
        fieldGap: 8,
    },
    colors: {
        linkPrimary: '#340065',
        textDefault: '#403636',
        textPrimary: '#212121',
        grey3: '#efefef',
        grey5: '#e0e0e0',
        red9: '#ff4141',
        red3: '#ffebe8',
        amber2: '#fffae8',
        destructive: '#d32f2f',
        primary: '#303f9f',
        iconSlotBg: '#eeeeee',
        iconSlotBorder: 'rgba(0, 0, 0, 0.15)',
        placeholder: '#8d8d8d',
    },
    typography: {
        bodyLarge: {
            fontSize: '15px',
            fontWeight: 500,
            lineHeight: 'normal',
        },
        bodyDefault: {
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: 'normal',
        },
        label: {
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: 'normal',
        },
        legend: {
            fontSize: '12px',
            fontWeight: 400,
            lineHeight: 1.5,
        },
    },
} as const;
